<template>
  <section class="steps-main">
    <div class="steps-main__bg" />
    <div class="steps-main__content">
      <div class="step-head">
        <div class="container">
          <div class="head-row">
            <div class="head-row__position">
              <i18n path="forms.formHeader" tag="h2">
                <span>{{ this.$i18n.t("profiling.step") }}</span>
              </i18n>
            </div>
            <h1>{{ this.$i18n.t("profiling.stepDescription") }}</h1>
            <img src="@/assets/head-paso1.svg" class="head-row__img" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="box-form box-form--step2">
          <v-row>
            <v-spacer />
            <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
              <div v-if="counter === questions + 1">
                <h2 class="text-header">{{ this.$i18n.t("profiling.intro") }}</h2>
                <div class="col-form">
                  <div class="col-form__item">
                    <label>{{ this.$i18n.t(`profiling.questions.${counter}.question`) }}</label>
                    <v-radio-group v-model="referredFrom">
                      <v-radio v-for="n in referredOptions" :key="n"
                        :label="$i18n.t(`profiling.questions.${counter}.answers.${n}`)" :value="n" />
                    </v-radio-group>
                    <div class="col-form">
                      <div class="col-form__item">
                        <v-text-field id="profiling-other" v-if="referredFrom === referredOptions" v-model="other"
                          :label="$i18n.t('profiling.other')" />
                      </div>
                    </div>
                  </div>
                </div>
                <v-row>
                  <v-spacer />
                  <v-btn :class="{ 'btn-finish': true, }" color="primary" :disabled="!referredFrom" id="profile-next"
                    @click="counter += 1">
                    {{ this.$i18n.t("profiling.buttons.next") }}
                  </v-btn>
                  <v-spacer />
                </v-row>
              </div>
              <div v-else-if="counter <= questions">
                <h2 class="text-header">{{ this.$i18n.t("profiling.intro") }}</h2>
                <div class="col-form">
                  <div class="col-form__item">
                    <label>{{ `${counter}/${questions} .- ` + this.$i18n.t(`profiling.questions.${counter}.question`)
                    }}</label>
                    <v-radio-group v-model="answers[counter]">
                      <v-radio v-for="n in options" :key="n"
                        :label="$i18n.t(`profiling.questions.${counter}.answers.${n}`)" :value="n" />
                    </v-radio-group>
                  </div>
                </div>
                <v-row>
                  <v-spacer />
                  <v-btn :class="{ 'btn-finish': true, }" color="primary" :disabled="!answers[counter]"
                    id="profile-next" @click="counter += 1">
                    {{ this.$i18n.t("profiling.buttons.next") }}
                  </v-btn>
                  <v-spacer />
                </v-row>
              </div>
              <div v-else>
                <i18n path="profiling.profiles.main" tag="h2" class="text-header">
                  <span class="text-blue">{{ this.$i18n.t(`profiling.profiles.options.${getProfile()}.name`) }}</span>
                </i18n>
                <p>{{ this.$i18n.t(`profiling.profiles.options.${getProfile()}.description`) }}</p>
                <br />
                <v-row>
                  <v-spacer />
                  <v-btn class="btn-finish" color="primary" id="profile-contiinue" @click="saveProfile">
                    {{ this.$i18n.t("profiling.buttons.continue") }}
                  </v-btn>
                  <v-spacer />
                </v-row>
                <br />
                <v-row>
                  <v-spacer />
                  <v-btn :class="{
                    'btn-finish': true,
                  }" id="profile-retry" @click="counter = 1">{{ this.$i18n.t("profiling.buttons.tryAgain") }}
                  </v-btn>
                  <v-spacer />
                </v-row>
              </div>
            </v-col>
            <v-spacer />
          </v-row>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Profiling",
  data() {
    return {
      questions: 6,
      counter: 1,
      options: 4,
      referredOptions: 5,
      answers: {
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
        6: null,
      },
      referredFrom: null,
      other: null,
    };
  },
  methods: {
    getProfile() {
      const total = Object.values(this.answers).reduce((a, b) => a + b);
      if (total <= 8) {
        return "low";
      }
      if (total <= 11) {
        return "belowAverage";
      }
      if (total <= 14) {
        return "average";
      }
      if (total <= 17) {
        return "aboveAverage";
      }
      return "high";
    },
    getReferredText() {
      if (this.referredFrom === this.referredOptions && this.other) {
        return this.other;
      }
      return this.$i18n.t(`profiling.questions.${this.questions + 1}.answers.${this.referredFrom}`);
    },
    saveProfile() {
      this.$store.commit("updateProfilingData", {
        profiling: Object.values(this.answers).reduce((a, b) => a + b),
        referredFrom: this.getReferredText(),
      });
      this.$store.commit("updateFormStep", { step: 4 });
      this.$router.push("declarations");
    },
  },
};
</script>

<style scoped>
.text-blue {
  color: #0000d6;
}
</style>
